import React from "react";
import { Redirect } from "react-router-dom";

import { Role } from "@teamrota/authlib";
import useAuth from "~/src/auth/hooks/use-auth";
import { useProfile } from "~/src/containers/profile-loader";

export default () => {
  const { authed, roles } = useAuth();
  const { user } = useProfile();

  if (authed) {
    if (roles.includes(Role.REQUESTER)) {
      if (roles.includes(Role.TIMESHEETS)) {
        const hasNewTimesheets = !!(
          user?.account?.newTimesheetsStartDate ||
          user?.account?.requesterConnections?.data[0]?.sourceAccount
            ?.newTimesheetsStartDate
        );

        return (
          <Redirect to={hasNewTimesheets ? "/timesheets-new" : "/timesheets"} />
        );
      }
      return <Redirect to="/request" />;
    } else if (roles.includes(Role.PROVIDER)) {
      return <Redirect to="/provide" />;
    } else if (roles.includes(Role.GENERAL_SETTINGS_VIEW)) {
      return <Redirect to="/settings" />;
    }
  }
};
